import React from "react";
import tawnyTitle from "../assets/logo.webp";

export interface LogoTitleProps {
	size: number;
}

const LogoView: React.FC<LogoTitleProps> = (props) => {
	return (
		<div className={"flex items-center title text-3xl gap-2"}>
			{props.size > 0 && (
				<img
					alt={
						"The logo of TawnyList, it's an owl face that looks like a checkbox. The big green eyebrows resemble a green checkmark."
					}
					src={tawnyTitle}
					width={props.size}
				/>
			)}
			TawnyList
		</div>
	);
};

export { LogoView };
